(() => {
  if (window.pampasProductMobileFix) return;
  window.pampasProductMobileFix = true;

  const isProductPage = () =>
    document.body && document.body.classList.contains('template-product');

  const flashyRoots = new Set();
  const flashyMobileStyles = `
    @media only screen and (max-width: 768px) {
      :host {
        max-width: 100vw !important;
      }

      .fls-popup-overlay {
        box-sizing: border-box !important;
        max-width: 100vw !important;
        padding: 12px !important;
        overflow: auto !important;
      }

      .fls-popup-overlay .fls-popup {
        box-sizing: border-box !important;
        width: min(600px, calc(100vw - 24px)) !important;
        max-width: calc(100vw - 24px) !important;
        max-height: calc(100dvh - 24px) !important;
      }

      .fls-popup-overlay .fls-close {
        display: inline-grid !important;
        place-items: center !important;
        min-width: 44px !important;
        min-height: 44px !important;
        touch-action: manipulation;
      }
    }
  `;

  const closeFlashyOverlay = (overlay) => {
    const closeButton = overlay.querySelector('.fls-close');
    if (closeButton instanceof HTMLElement) closeButton.click();
  };

  const handleOverlayClick = (event) => {
    if (!isProductPage() || !(event.target instanceof Element)) return;

    const overlay = event.target.closest('.fls-popup-overlay');
    if (!overlay || event.target.closest('.fls-popup')) return;

    event.preventDefault();
    closeFlashyOverlay(overlay);
  };

  const attachFlashyRoot = (root) => {
    if (!root || flashyRoots.has(root)) return;
    flashyRoots.add(root);

    const style = document.createElement('style');
    style.dataset.pampasProductMobileFix = 'true';
    style.textContent = flashyMobileStyles;
    root.appendChild(style);
    root.addEventListener('click', handleOverlayClick, true);
  };

  const attachFlashyPopups = () => {
    document.querySelectorAll('flashy-popup').forEach((host) => {
      attachFlashyRoot(host.shadowRoot);
    });
  };

  document.addEventListener('click', handleOverlayClick, true);

  document.addEventListener('keydown', (event) => {
    if (!isProductPage() || event.key !== 'Escape') return;

    document.querySelectorAll('.fls-popup-overlay').forEach(closeFlashyOverlay);
    flashyRoots.forEach((root) => {
      root.querySelectorAll('.fls-popup-overlay').forEach(closeFlashyOverlay);
    });
  });

  new MutationObserver(attachFlashyPopups).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('DOMContentLoaded', attachFlashyPopups);
  attachFlashyPopups();

  const flashyTimer = window.setInterval(attachFlashyPopups, 250);
  window.setTimeout(() => window.clearInterval(flashyTimer), 15000);
})();
